/* LaFarmacia - carrito unificado (mismo flujo que Dawn: /cart/add + sections)
   - Botones: "+" del buscador, "Agregar" de Mas vendidos y de Ofertas flash.
   - Aviso y contador al instante; la cesta NO se abre sola.
   - El cajon se rellena con la respuesta del servidor y se refresca cada vez que se abre.
   - IMPORTANTE: esta version YA NO sobrescribe window.fetch. Esta tienda ya tiene otros
     scripts que envuelven fetch (pixel de Shopify, Web Pixels Manager y la app Connectif);
     sumar una capa propia con reintentos en cadena era lo que causaba el retraso de varios
     segundos y el "ya esta agotado" en productos que si tenian stock. Ahora se hace UNA sola
     llamada directa a Shopify, igual que el formulario nativo de producto de Dawn. */
(function(){
  if(window.__lafCart) return; window.__lafCart = true;

  var SEL = '.laf-add[data-variant-id], .laf-card__buy[data-variant], .laf-bcard__buy[data-variant], .quick-add__submit[name="add"]';
  var SECTIONS = 'cart-drawer,cart-icon-bubble';
  function root(){ return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function drawer(){ return document.querySelector('cart-drawer'); }
  function parse(html){ return new DOMParser().parseFromString(html, 'text/html'); }

  /* ---------- aviso ---------- */
  function toast(msg, isErr){
    var t = document.getElementById('laf-toast');
    if(!t){ t = document.createElement('div'); t.id = 'laf-toast'; t.className = 'laf-toast'; t.setAttribute('role','status'); t.setAttribute('aria-live','polite'); document.body.appendChild(t); }
    t.textContent = msg;
    t.classList.toggle('laf-toast--err', !!isErr);
    t.classList.add('show');
    clearTimeout(t._h); t._h = setTimeout(function(){ t.classList.remove('show'); }, isErr ? 4500 : 2200);
  }

  /* ---------- contador ---------- */
  function bubbles(){
    var list = document.querySelectorAll('.cart-count-bubble');
    if(!list.length){
      var icon = document.getElementById('cart-icon-bubble');
      if(icon){ var nb = document.createElement('div'); nb.className = 'cart-count-bubble'; nb.innerHTML = '<span aria-hidden="true">0</span>'; icon.appendChild(nb); list = document.querySelectorAll('.cart-count-bubble'); }
    }
    return list;
  }
  function spanOf(b){ return b.querySelector('span[aria-hidden], span:not(.visually-hidden)'); }
  function setCount(n){
    var list = bubbles();
    for(var i = 0; i < list.length; i++){
      var b = list[i], s = spanOf(b);
      if(n > 0){ b.style.display = ''; b.classList.remove('hidden'); if(s){ s.textContent = n; } else { b.textContent = n; } }
      else { b.style.display = 'none'; }
    }
  }
  function syncExact(){
    fetch(root() + 'cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(c){ setCount(c.item_count); })
      .catch(function(){});
  }

  /* ---------- cajon: pintar sin abrir ---------- */
  function applySections(sections){
    if(!sections) return;
    var d = drawer();
    if(d && sections['cart-drawer']){
      var doc = parse(sections['cart-drawer']);
      var src = doc.querySelector('#CartDrawer'), dst = document.getElementById('CartDrawer');
      if(src && dst){ dst.innerHTML = src.innerHTML; }
      var srcEl = doc.querySelector('cart-drawer');
      if(srcEl){ d.classList.toggle('is-empty', srcEl.classList.contains('is-empty')); }
      var ov = d.querySelector('#CartDrawer-Overlay');
      if(ov && typeof d.close === 'function'){ ov.addEventListener('click', d.close.bind(d)); }
    }
    if(sections['cart-icon-bubble']){
      var sb = parse(sections['cart-icon-bubble']).querySelector('.cart-count-bubble span[aria-hidden], .cart-count-bubble span');
      var n = sb ? parseInt(sb.textContent, 10) : 0;
      setCount(isNaN(n) ? 0 : n);
    }
  }
  var refreshing = null;
  function refreshFromServer(){
    if(refreshing) return refreshing;
    refreshing = fetch(root() + '?sections=' + SECTIONS)
      .then(function(r){ return r.json(); })
      .then(function(s){ applySections(s); })
      .catch(function(){})
      .then(function(){ refreshing = null; });
    return refreshing;
  }
  /* tras anadir: si habia una carga en curso (empezada antes de anadir) se espera y se vuelve a pedir */
  function refreshFresh(){ return refreshing ? refreshing.then(refreshFromServer) : refreshFromServer(); }
  /* cada vez que se abre el cajon (icono, barra de envio, etc.) se trae el contenido real */
  function patchDrawer(){
    var C = window.customElements && customElements.get('cart-drawer');
    if(!C || C.prototype.__lafPatched) return;
    C.prototype.__lafPatched = true;
    var orig = C.prototype.open;
    C.prototype.open = function(){ var r = orig.apply(this, arguments); refreshFromServer(); return r; };
  }
  if(window.customElements){ customElements.whenDefined('cart-drawer').then(patchDrawer); }
  /* se adelanta la carga de la cesta en cuanto el dedo o el raton se acercan al icono */
  function precarga(e){ var ic = e.target && e.target.closest ? e.target.closest('#cart-icon-bubble') : null; if(ic && drawer()){ refreshFromServer(); } }
  document.addEventListener('pointerover', precarga, {passive:true});
  document.addEventListener('touchstart', precarga, {passive:true});

  /* ---------- estado del boton: "anadiendo" -> "anadido" (solo cuando Shopify confirma) ---------- */
  function setBtn(btn, txt){
    var span = btn.querySelector('span');
    if(span && !btn.classList.contains('laf-add')){ span.textContent = txt; } else { btn.textContent = txt; }
  }
  function busy(btn){
    clearTimeout(btn.__lafT);
    if(btn.__lafOld === undefined){ btn.__lafOld = btn.innerHTML; }
    btn.disabled = true; btn.classList.add('is-busy');
    setBtn(btn, btn.classList.contains('laf-add') ? '…' : 'Añadiendo…');
  }
  function done(btn, ok){
    btn.classList.remove('is-busy');
    var restoreBtn = function(){ if(btn.__lafOld !== undefined){ btn.innerHTML = btn.__lafOld; btn.__lafOld = undefined; } btn.disabled = false; };
    if(!ok){ restoreBtn(); return; }
    setBtn(btn, btn.classList.contains('laf-add') ? '✓' : '¡Añadido! ✓');
    btn.__lafT = setTimeout(restoreBtn, 1100);
  }

  /* ---------- anadir: UNA sola llamada directa, sin tocar window.fetch ---------- */
  function add(id, btn){
    busy(btn);
    var fd = new FormData();
    fd.append('id', id); fd.append('quantity', '1');
    /* Clau 9 oct 2026 (velocidad): al anadir solo se pide el numero del icono (rapido); la cesta
       completa (con sugerencias) se repinta justo despues en segundo plano. */
    if(drawer()){ fd.append('sections', 'cart-icon-bubble'); fd.append('sections_url', window.location.pathname); }
    var url = (window.routes && window.routes.cart_add_url) || (root() + 'cart/add.js');
    fetch(url, { method:'POST', headers:{'X-Requested-With':'XMLHttpRequest','Accept':'application/javascript'}, body: fd })
      .then(function(r){ return r.json().then(function(j){ return { ok: r.ok, data: j }; }); })
      .then(function(res){
        if(!res.ok || (res.data && res.data.status)){ throw res.data; }
        var data = res.data;
        if(data && data.sections){ applySections(data.sections); } else { syncExact(); }
        toast('Añadido a la cesta');
        done(btn, true);
        if(drawer()){ refreshFresh(); }
        try{ if(window.publish && window.PUB_SUB_EVENTS){ publish(PUB_SUB_EVENTS.cartUpdate, {source:'laf-cart', productVariantId:id, cartData:data}); } }catch(e){}
        document.dispatchEvent(new CustomEvent('laf:cart:updated', {detail:data}));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function(err){
        var msg = err && (err.description || err.message);
        if(typeof msg !== 'string' || !msg){ msg = 'No se pudo añadir el producto'; }
        toast(msg, true);
        done(btn, false);
        syncExact();
      });
  }

  /* captura: este manejador sustituye a los antiguos de cada seccion (evita dobles anadidos
     y que la cesta se abra sola) */
  document.addEventListener('click', function(e){
    var b = e.target.closest ? e.target.closest(SEL) : null;
    if(!b) return;
    // Variant id: de los data-atributos de los botones propios, o -para el
    // boton de añadir rapido nativo de Dawn (.quick-add__submit)- del input
    // del <product-form>. Solo se intercepta el añadir DIRECTO (producto de
    // una sola variante, cuyo boton vive dentro de un product-form con
    // input[name=id]); el boton "elegir opciones" de un producto con varias
    // variantes vive en un <modal-opener> sin ese input, asi que no entra
    // aca y abre su modal normal para que el cliente elija la variante.
    var id = b.getAttribute('data-variant-id') || b.getAttribute('data-variant');
    if(!id){
      var form = b.closest ? b.closest('product-form') : null;
      var input = form ? form.querySelector('input[name="id"]:not([disabled])') : null;
      if(input) id = input.value;
    }
    if(!id) return;
    // Recien aca (con id confirmado) se corta el comportamiento nativo: asi el
    // click en el boton de "elegir opciones" no se bloquea y su modal se abre.
    e.preventDefault(); e.stopPropagation(); if(e.stopImmediatePropagation) e.stopImmediatePropagation();
    if(b.disabled || b.classList.contains('laf-add--out')) return;
    add(id, b);
  }, true);

  document.addEventListener('cart:updated', syncExact);
  /* applySections + toast se exponen (igual que en el diseño nuevo) para que el formulario de la
     ficha (assets/product-form.js) use el mismo flujo: aviso y contador al instante, y la cesta
     solo se abre al tocar el icono del carrito. */
  window.lafCart = { add: add, refresh: refreshFresh, sync: syncExact, applySections: applySections, toast: toast };
})();
